import * as React from "react";
import type { SVGProps } from "react";
const SvgCaretRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M8.474 18.966 15.44 12 8.474 5.033"
    />
  </svg>
);
export default SvgCaretRight;
